import { useEffect, useState } from "react";
import pro from "assets/hm_service_image/des/pro-desktop.png";
import duo from "assets/hm_service_image/des/duo-desktop.png";
import promb from "assets/hm_service_image/des/pro-mobile.png";
import duomb from "assets/hm_service_image/des/duo-mobile.png";

import IPhone18ProMax from "pages/ComingSoon/components/infoproduct/18promax";
import IPhone18Pro from "pages/ComingSoon/components/infoproduct/18pro";
import Duo from "pages/ComingSoon/components/infoproduct/duo";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

function InfoTabs() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(1);

  useEffect(() => {
    const path = location.pathname;

    if (path.includes("iphone-18-pro-max")) {
      setActiveTab(1);
    } else if (
      path.includes("iphone-18-pro-256gb") ||
      path.includes("iphone-18-pro-512gb") ||
      path.includes("iphone-18-pro-1tb") ||
      path.includes("iphone-18-pro-2tb")
    ) {
      setActiveTab(2);
    } else if (path.includes("iphone-duo")) {
      setActiveTab(3);
    }
  }, [location.pathname]);

  return (
    <div className="image-tabs">
      <h2>Bạn đang quan tâm đến sản phẩm nào?</h2>
      {/* Tab buttons */}
      <div className="tab-buttons">
        <button
          className={activeTab === 1 ? "active" : ""}
          onClick={() => setActiveTab(1)}
        >
          iPhone 18 Pro Max
        </button>
        <button
          className={activeTab === 2 ? "active" : ""}
          onClick={() => setActiveTab(2)}
        >
          iPhone 18 Pro
        </button>
        <button
          className={activeTab === 3 ? "active" : ""}
          onClick={() => setActiveTab(3)}
        >
          iPhone Duo
        </button>
      </div>

      {/* Tab content */}
      <div className="tab-content">
        {activeTab === 1 && (
          <>
            <img src={pro} alt="Ảnh iPhone Pro" className="f-desktop" width="100%" />
            <img src={promb} alt="Ảnh iPhone Pro" className="f-mb" width="100%" />
            <IPhone18ProMax />
          </>
        )}
        {activeTab === 2 && (
          <>
            <img src={pro} alt="Ảnh iPhone Pro" className="f-desktop" width="100%" />
            <img src={promb} alt="Ảnh iPhone ProẢnh mobile 1" className="f-mb" width="100%" />
            <IPhone18Pro />
          </>
        )}
        {activeTab === 3 && (
          <>
            <img src={duo} alt="Ảnh iPhone Duo" className="f-desktop" width="100%" />
            <img src={duomb} alt="Ảnh iPhone Duo" className="f-mb" width="100%" />
            <Duo />
          </>
        )}
      </div>


    </div>
  );
}

export default InfoTabs;
